import axios from 'axios';
import * as Cookies from '../utils/cookies';

/**
 * Request OTP code to be sent via SMS.
 * POST /api/auth/request_otp/
 */
export async function requestOtp(phoneNumber) {
  try {
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + '/api/auth/request_otp/',
      data: { phone_number: phoneNumber },
    });
    return {
      requestId: res.data.request_id,
      expiresIn: res.data.expires_in,
    };
  } catch (error) {
    console.log(error);
    console.error('[requestOtp] error:', error);
    if (error.response?.status === 429) {
      return { error: 'rate_limit', message: 'שלחת יותר מדי בקשות, נסה שוב בעוד מספר דקות' };
    }
    return { error: 'unknown', message: 'שגיאה במספר הטלפון' };
  }
}

/**
 * Verify the OTP code.
 * POST /api/auth/verify_otp/
 *
 * Existing user → stores token in cookie, returns { isNewUser: false }
 * New user      → returns { isNewUser: true, tempToken, phoneNumber } (does NOT store temp_token)
 */
export async function verifyOtp({ requestId, code }) {
  try {
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + '/api/auth/verify_otp/',
      data: { request_id: requestId, code },
    });

    if (!res.data.is_new_user) {
      Cookies.setToken(res.data.token);
      return { isNewUser: false };
    }

    return {
      isNewUser: true,
      tempToken: res.data.temp_token,
      phoneNumber: res.data.phone_number,
    };
  } catch (error) {
    console.error('[verifyOtp] error:', error);
    if (error.response?.status === 400) {
      return { error: 'bad_code', message: error.response.data?.detail || 'קוד האימות שגוי או פג תוקף' };
    }
    return { error: 'unknown', message: 'שגיאה באימות, נסה שוב' };
  }
}

/**
 * Register a new user after OTP verification.
 * POST /api/users/users/register_otp/
 * Requires the temp_token from verifyOtp as a Bearer token.
 *
 * On success stores the real auth token in the cookie and returns { user }.
 */
export async function registerOtp(
  { firstName, lastName, city, grade, shirtSize, wantCaptain },
  tempToken,
) {
  try {
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + '/api/users/users/register_otp/',
      headers: { Authorization: `Bearer ${tempToken}` },
      data: {
        first_name: firstName,
        last_name: lastName,
        city,
        grade,
        shirt_size: shirtSize,
        want_captain: wantCaptain,
      },
    });
    Cookies.setToken(res.data.token);
    return { user: res.data.user };
  } catch (error) {
    console.error('[registerOtp] error:', error);
    if (error.response?.status === 401) {
      return { error: 'invalid_temp_token', message: 'פג תוקף ההרשמה, יש להתחיל מחדש' };
    }
    if (error.response?.status === 400) {
      return { error: 'validation', message: error.response.data?.detail || 'שגיאה בפרטי ההרשמה' };
    }
    return { error: 'unknown', message: 'שגיאה בהרשמה, נסה שוב' };
  }
}

